module.exports = __webpack_public_path__ + "static/media/hotstar_logo.a916ea60.svg";